module.exports = __webpack_public_path__ + "fonts/subset-MullerLight.e2ef16a5.woff";